import { Spinner, Text } from '@chakra-ui/react';

function FreeCashFlowHistoryTable({ tickerSymbol, loading, operatingCashFlows }) {
    if (loading) {
        return (
            <>
                <Spinner size='xl' color='green.500' />
                <Text mt={2}>Fetching financial data…</Text>
            </>
        );
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <h2>Free Cash Flow History for {tickerSymbol.toUpperCase()}</h2>
            <table style={{ width: '100%' }}>
                <thead>
                    <tr>
                        <th>Year</th>
                        <th>Operating Cash Flow</th>
                        <th>Capital Expenditures</th>
                        <th>Free Cash Flow</th>
                    </tr>
                </thead>
                <tbody>
                    {[...operatingCashFlows]
                        .reverse()
                        .map((entry, index, array) => {
                            const currentFreeCashFlow = entry.operatingCashFlows && entry.capitalExpenditures
                                ? entry.operatingCashFlows - entry.capitalExpenditures
                                : null;

                            const previousEntry = array[index + 1];
                            const previousFreeCashFlow = previousEntry?.operatingCashFlows && previousEntry.capitalExpenditures
                                ? previousEntry.operatingCashFlows - previousEntry.capitalExpenditures
                                : null;

                            const rowGrowthRate = previousFreeCashFlow && currentFreeCashFlow
                                ? ((currentFreeCashFlow - previousFreeCashFlow) / previousFreeCashFlow) * 100
                                : null;

                            return (
                                <tr key={entry.year}>
                                    <td>{entry.year}</td>
                                    <td>{entry.operatingCashFlows ? `$${entry.operatingCashFlows.toLocaleString()}` : '-'}</td>
                                    <td>{entry.capitalExpenditures ? `$${entry.capitalExpenditures.toLocaleString()}` : '-'}</td>
                                    <td>{currentFreeCashFlow !== null ? `$${currentFreeCashFlow.toLocaleString()}` : '-'}</td>
                                    <td>{rowGrowthRate !== null ? `${rowGrowthRate.toFixed(2)}%` : '-'}</td>
                                </tr>
                            );
                        })}
                </tbody>
            </table>
        </div>
    );
}

export default FreeCashFlowHistoryTable;
